import { useState } from 'react'
import { api } from 'lib/axios'

const BatchOCRMultiThread = async payload => {
  const response = await api.post(
    '/Api/V8/custom/customer/batch-ocr-process-multithreaded',
    payload
  )
  return response
}

export const useBatchOCRMultiThread = () => {
  const [
    isBatchOCRMultiThreadDataLoading,
    setIsBatchOCRMultiThreadDataLoading
  ] = useState(false)

  const handleBatchOCRMultiThread = async payload => {
    setIsBatchOCRMultiThreadDataLoading(true)
    try {
      const response = await BatchOCRMultiThread(payload)
      if (response) {
        // toast.success('Batch OCR successful')
        return response
      } else {
        //  toast.error('Batch OCR failed')
        console.error('Batch OCR Multi Thread failed:', response)
        return null
      }
    } catch (error) {
      //  toast.error('Batch OCR failed')
      console.error('Batch OCR Multi Thread failed:', error)
    } finally {
      setIsBatchOCRMultiThreadDataLoading(false)
    }
  }

  return {
    isBatchOCRMultiThreadDataLoading,
    handleBatchOCRMultiThread
  }
}
